import { render, staticRenderFns } from "./JourneyLayout.vue?vue&type=template&id=59522e26&scoped=true"
import script from "./JourneyLayout.vue?vue&type=script&lang=js"
export * from "./JourneyLayout.vue?vue&type=script&lang=js"
import style0 from "./JourneyLayout.vue?vue&type=style&index=0&id=59522e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59522e26",
  null
  
)

export default component.exports